<template>
  <div
    class="border-situational-lightgrey divide-situational-lightgrey w-full divide-y"
  >
    <div class="bg-background-neutral-primary sticky top-0 z-10">
      <div class="bg-background-neutral-secondary rounded-t-2xl px-4">
        <FreeCheckbox
          class="flex justify-between py-4"
          :checked="!!state.isImplicitAllAirlines"
          type="checkbox"
          @change="selectAllAirlines"
        >
          <template #content>
            <p class="text-text-positive-primary text-base font-semibold">
              {{ $t('search.filters.allAirlines') }}
            </p>
          </template>
        </FreeCheckbox>
      </div>
    </div>
    <div
      class="bg-background-neutral-secondary border-situational-lightgrey divide-situational-lightgrey divide-y rounded-b-2xl px-4"
    >
      <FreeCheckbox
        v-for="airline in mappedAirlines"
        :key="airline.iata"
        type="checkbox"
        class="flex justify-between py-4"
        :checked="airline.isSelected"
        @change="updateAirlinesFilter(airline.iata)"
      >
        <template #content>
          <div class="flex items-center space-x-3">
            <AirlineIcon
              :size="AirlineIconSizeEnum.large"
              :airline="{ iata: airline.iata, title: airline.title }"
            />
            <p class="text-text-neutral-primary text-base font-medium">
              {{ airline.title }}
            </p>
          </div>
        </template>
      </FreeCheckbox>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { uniq } from 'lodash-es';
  import { setAllAirlines } from '@aviata/offers-filters-fns';
  import {
    FreeCheckbox,
    AirlineIcon,
    AirlineIconSizeEnum,
  } from 'freedom-shared';
  import { airlineFilters } from 'shared';
  import type { Dict } from '@aviata/platform-types';

  const props = defineProps<{
    airlines: Dict.Entity['airlines'];
    state: airlineFilters.types.AirlineFiltersState;
  }>();

  const emit = defineEmits<{
    (
      e: 'onAirlinesFilterChange',
      payload: airlineFilters.types.AirlineFiltersState,
    ): void;
  }>();

  const mappedAirlines = computed(() =>
    airlineFilters.lib.mapAirlines(props.state, props.airlines),
  );

  const updateAirlinesFilter = (airlineIata: string) => {
    const { airlines } = props.state;
    const newState = {
      ...airlines,
      [airlineIata]: !airlines[airlineIata],
    };

    emit('onAirlinesFilterChange', {
      airlines: newState,
      isAllAirlines: uniq(Object.values(newState)).length === 1,
      isImplicitAllAirlines: Object.values(newState).every(Boolean),
    });
  };

  const selectAllAirlines = (event: Event) => {
    const { checked } = event.target as HTMLInputElement;

    emit('onAirlinesFilterChange', {
      airlines: setAllAirlines(props.state.airlines, checked),
      isAllAirlines: true,
      isImplicitAllAirlines: checked,
    });
  };
</script>
